import React from 'react'
import classNames from 'classnames'
import './CardGrid.less'

export interface ICardGridProps {
  cards: React.ReactNode[]
  className?: string
  cutOffMessage?: React.ReactNode
  children?: any
}

const CardGrid = ({
  cards,
  className,
  cutOffMessage,
  children
}: ICardGridProps) => {
  return (
    <div className={classNames('CardGrid', className)}>
      <div className="CardGrid__items">
        {cards.map((card, idx) => {
          return (
            <div key={idx} className="CardGrid__item">
              {card}
            </div>
          )
        })}

        {children && <div className="CardGrid__item">{children}</div>}
      </div>
      {cutOffMessage}
    </div>
  )
}

export default CardGrid
